import angular from 'angular'
import 'angular-animate'
import 'angular-chart.js'
import 'angular-filter'
import 'angular-grid'
import 'angular-grid/dist/angular-grid.min.css'
import 'angular-marked'
import 'angular-message-format'
import 'angular-messages'
import 'angular-translate'
import 'angular-ui-router'
import Chart from 'chart.js'
import 'marked'
import moment from 'moment'
import 'moment/locale/es'
import 'ngstorage'
import 'ng-img-crop/compile/minified/ng-img-crop.js'
import 'ng-img-crop/compile/minified/ng-img-crop.css'
import 'font-awesome/scss/font-awesome.scss'
import 'roboto-fontface/css/roboto/sass/roboto-fontface-thin.scss'
import 'roboto-fontface/css/roboto/sass/roboto-fontface-light.scss'
import 'roboto-fontface/css/roboto/sass/roboto-fontface-regular.scss'
import 'roboto-fontface/css/roboto/sass/roboto-fontface-bold.scss'
import Trianglify from 'trianglify'
/* Modulos */
import 'fan/index.js'
import 'recursoshumanos/index.js'
import prestamosExternos from 'prestamosExternos/index.js'
import 'nominas/index.js'
import 'contabilidad/index.js'
import appModule from 'app/index.js'
import catalogoModule from 'catalogo/index.js'
import chequesModule from 'cheques/index.js'
import clientesModule from 'clientes/index.js'
import clienteModule from 'cliente/index.js'
import colaboradorModule from 'colaborador/index.js'
import contabilidadModule from 'contabilidad/index.js'
import empresasModule from 'empresas/index.js'
import empresaModule from 'empresa/index.js'
import facturacionModule from 'facturacion/index.js'
import fanconsultoresModule from 'fanconsultores/index.js'
import finanzasModule from 'finanzas/index.js'
import guestModule from 'guest/index.js'
import nominasModule from 'nominas/index.js'
import usuarioModule from 'usuario/index.js'
import usuariosModule from 'usuarios/index.js'
import viaticoModule from 'viatico/index.js'
import viaticosModule from 'viaticos/index.js'

moment.locale('es')

window.angular = angular
window.Chart = Chart
window.Trianglify = Trianglify
window.moment = moment

angular.element(() => (angular.bootstrap(document, [
  // App
  appModule,
  // Catálogo
  catalogoModule,
  // Cheques
  chequesModule,
  // Clientes
  clientesModule,
  // Cliente
  clienteModule,
  // Colaborador
  colaboradorModule,
  // Contabilidad
  contabilidadModule,
  // Empleados
  'empleados.empleado',
  'empleados.respaldo',
  'empleados.shared',
  'empleados.sumario',
  'empleados.templates',
  // Empresa
  empresaModule,
  // Empresas
  empresasModule,
  // Fan
  'fan',
  'fan.proyectos',
  'fan.proyecto',
  // Facturación
  facturacionModule,
  // Fanconsultores
  fanconsultoresModule,
  // Finanzas
  finanzasModule,
  // Gastos
  'gastos.main',
  'gastos.templates',
  // Guest
  guestModule,
  // Nóminas
  nominasModule,
  // Préstamos externos
  prestamosExternos,
  // Recursos humanos
  'recursoshumanos',
  // Usuario
  usuarioModule,
  // Usuarios
  usuariosModule,
  // Viaticos
  viaticoModule,
  viaticosModule,
], {strictDi: true})))



// WEBPACK FOOTER //
// ./src/index.js